import { DownloadOutlined } from '@ant-design/icons';
import { Button, DatePicker, Table } from "antd";
import "bootstrap-icons/font/bootstrap-icons.css";
import { useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { useDispatch, useSelector } from "react-redux";
import ColVisibilityDropdown from "../Shared/ColVisibilityDropdown";
import { CsvLinkBtn } from "../UI/CsvLinkBtn";

import moment from 'moment';
import { useParams } from "react-router-dom";
import { getDocumentsByUserId } from "../../redux/rtk/features/document/documentSlice";
import getUserFromToken from "../../utils/getUserFromToken";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";
import UpdateDocumentModal from "./updateDocument";

function CustomTable({ list, loading, currentPage = 1, pageSize = 100, onPageChange }) {
    const [columnsToShow, setColumnsToShow] = useState([]);
    const { RangePicker } = DatePicker;
    const [fromDate, setFromDate] = useState(moment().startOf("month").format("YYYY-MM-DD"));
    const [toDate, setToDate] = useState(moment().endOf("month").format("YYYY-MM-DD"));
    const [filteredList, setFilteredList] = useState([]);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState(null);

    const handleUpdateClick = (record) => {
        setSelectedRecord(record);
        setIsModalVisible(true);
    };

    const handleModalClose = () => {
        setIsModalVisible(false);
        setSelectedRecord(null);
    };


    const handleDownload = (url, fileName) => {
        const token = getUserFromToken();
        if (!token) {
            console.error("Authorization token missing");
            return;
        }

        fetch(url, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${localStorage.getItem("access-token")}`,
            },
        })
            .then((response) => {
                if (response.ok) {
                    return response.blob();
                } else {
                    throw new Error("Authorization failed");
                }
            })
            .then((blob) => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = fileName || "document";
                document.body.appendChild(a);
                a.click();
                a.remove();
            })
            .catch((error) => {
                console.error("Error downloading document: ", error);
            });
    };

    const columns = [
        {
            title: "S.No.",
            dataIndex: "sno",
            key: "sno",
            render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
        },
        {
            title: "Document Type ",
            dataIndex: "documentType",
            key: "documentType",
            render: (text, record) => record.document_type?.documentType || "N/A",
            
        },
        {
            title: "Download File",
            dataIndex: "documentProofUrl",
            key: "documentProofUrl",
            render: (url, record) => {
                if (record.uploadFile === null) {
                    return <span style={{ color: 'red' }}>No documents available</span>;
                }
                if (!url) {
                    return <span>No data</span>;
                } else {
                    return (
                        <a
                            href="#"
                            onClick={(e) => {
                                e.preventDefault();
                                handleDownload(url, `${record.documentName}`);
                            }}
                            style={{ color: 'green', display: 'flex', alignItems: 'center' }}
                        >
                            <DownloadOutlined style={{ marginRight: 8 }} />
                           
                        </a>
                    );
                
                }
            },
        },

       { 
        title: 'Action',
        key: 'action',
        render: (_, record) => (
            <Button
                type="primary"
                onClick={() => handleUpdateClick(record)}
                className="ml-2"
            >
                Update
            </Button>
        ),
    },
];


    useEffect(() => {
        setColumnsToShow(columns);
    }, []);

    useEffect(() => {
        if (list) {
            const filtered = list.filter(item => {
                const expDate = moment(item.createdAt).format("YYYY-MM-DD");
                return expDate >= fromDate && expDate <= toDate;
            });
            setFilteredList(filtered);
        } else {
            setFilteredList([]);
        }
    }, [fromDate, toDate, list]);

    const columnsToShowHandler = (val) => {
        setColumnsToShow(val);
    };

    return (
        <div className="ant-card p-4 rounded mt-5">
            <div className="flex my-2 justify-between">
                <div className="w-50">
                    <h4 className="text-2xl mb-2"> Document List</h4>
                </div>
                {/* <div>
                    <RangePicker
                        defaultValue={[moment().startOf("month"), moment().endOf("month")]}
                        onChange={(dates) => {
                            if (dates) {
                                setFromDate(moment(dates[0]).format("YYYY-MM-DD"));
                                setToDate(moment(dates[1]).format("YYYY-MM-DD"));
                            }
                        }}
                    />
                </div> */}
                {filteredList && (
                    <div className="flex justify-end mr-4">
                        <div className="mt-0.5">
                            <CsvLinkBtn>
                                <CSVLink
                                    data={filteredList}
                                    className="btn btn-dark btn-sm"
                                    style={{ marginTop: "5px" }}
                                    filename="document_forms"
                                >
                                    Download CSV
                                </CSVLink>
                            </CsvLinkBtn>
                        </div>
                    </div>
                )}
            </div>
            {filteredList && (
                <div style={{ marginBottom: "30px" }}>
                    <ColVisibilityDropdown
                        options={columns}
                        columns={columns}
                        columnsToShowHandler={columnsToShowHandler}
                    />
                </div>
            )}
            <Table
                className="text-center"
                scroll={{ x: true }}
                loading={loading}
                columns={columnsToShow}
                dataSource={
                    filteredList.map((item, index) => ({ ...item, key: index }))
                }
                pagination={{
                    current: currentPage,
                    pageSize: pageSize,
                    total: filteredList.length,
                }}
                summary={() => (
                    <Table.Summary.Row>
                        <Table.Summary.Cell></Table.Summary.Cell>
                        <Table.Summary.Cell></Table.Summary.Cell>
                        <Table.Summary.Cell></Table.Summary.Cell>
                        <Table.Summary.Cell></Table.Summary.Cell>
                        <Table.Summary.Cell></Table.Summary.Cell>
                    </Table.Summary.Row>
                )}
            />
            <UpdateDocumentModal
                visible={isModalVisible}
                onCancel={handleModalClose}
                record={selectedRecord}
            />
        </div>
    );
}

const UserDocumentList = (props) => {
    const { id } = useParams("id");
    const userId = getUserFromToken();

    const dispatch = useDispatch();
    const list = useSelector((state) => state.document.document);
    const loading = useSelector((state) => state.document.loading);
    useEffect(() => {
        dispatch(getDocumentsByUserId(userId));
    }, []);
    console.log("list", list);
    return (
        <UserPrivateComponent permission={"readSingle-leaveApplication"}>
            <div className="card">
                <div className="card-body">
                    <CustomTable
                        list={list}
                        loading={loading}
                    ></CustomTable>
                </div>
            </div>
        </UserPrivateComponent>
    );
};

export default UserDocumentList;
